(() => {
  function init(scope = document) {
    scope.querySelectorAll('.me-contact-v03__form').forEach(form => {
      if (form.dataset.validationReady) return;
      const summary = form.querySelector('[data-me-contact-summary]');
      if (!summary) return;
      form.dataset.validationReady = 'true';
      form.noValidate = true;
      const fields = [...form.querySelectorAll('[required]')];
      let attempted = false;
      const validate = field => {
        const valid = field.validity.valid && (field.type === 'checkbox' || field.value.trim().length > 0);
        const error = document.getElementById(field.getAttribute('aria-describedby'));
        if (valid) field.removeAttribute('aria-invalid');
        else field.setAttribute('aria-invalid', 'true');
        if (error) error.hidden = valid;
        return valid;
      };
      const updateSummary = errors => {
        summary.hidden = errors.length === 0;
        summary.textContent = errors.length ? summary.dataset.message.replace('[count]', String(errors.length)) : '';
      };
      form.addEventListener('submit', event => {
        attempted = true;
        const errors = fields.filter(field => !validate(field));
        updateSummary(errors);
        if (errors.length) {
          event.preventDefault();
          errors[0].focus();
        }
      });
      fields.forEach(field => {
        const onEdit = () => {
          if (!attempted) return;
          validate(field);
          updateSummary(fields.filter(item => item.getAttribute('aria-invalid') === 'true'));
        };
        field.addEventListener('input', onEdit);
        field.addEventListener('change', onEdit);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
